<!--
 * @Author: 王丛
 * @Date: 2021-12-30 15:24:00
 * @LastEditors: 王丛
 * @LastEditTime: 2022-02-17 19:53:38
 * @Description: 搜索历史
-->
<template>
  <div v-show="historyList && historyList.length > 0" class="search-history ">
    <div>
      <div class="title">
        <span>历史搜索</span>
        <span
          v-show="showOpen"
          :class="['close-btn', openStatus && 'open']"
          @click="handleShowOpen"
          >{{ !openStatus ? '展开' : '收起' }}</span
        >
      </div>
      <ul
        ref="historyList"
        class="list"
        :style="{
          height: (openStatus ? historyListMaxLen : historyListMinLen) + 'px',
        }"
      >
        <li v-for="item in historyList" :key="item" @click="handleClick(item)">
          <span class="ellipsis">
            {{ item }}
          </span>
        </li>
      </ul>
      <p class="clear-history" @click="clear">
        <img
          src="https://resource.chunyu.mobi/@/media/images/2021/12/30/a941/b3669eeaa16d_w48_h48_.png"
        />
        <span>清空搜索历史</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // 历史记录列表
    historyList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showOpen: false,
      openStatus: false, // true 展开
      historyListMaxLen: '',
      historyListMinLen: '',
    };
  },
  watch: {
    historyList: {
      handler() {
        this.calcHistory();
      },
      deep: true,
    },
  },
  mounted() {
    this.calcHistory();
  },
  methods: {
    /**
     * @ description: 清除历史记录
     */
    clear() {
      this.$emit('clear');
    },
    /**
     * 点击历史词条
     *
     * @param {object} item 传入的参数
     */
    handleClick(item) {
      this.$emit('clickItem', item);
    },
    // 历史记录展开
    calcHistory() {
      const ulHeight = this.$refs.historyList.offsetHeight;
      this.historyListMaxLen = ulHeight;
      console.log(this.$refs.historyList.childNodes);
      const lis = this.$refs.historyList.childNodes;
      if (lis.length > 0) {
        const liHeight = lis[0].offsetHeight;
        if (ulHeight > 2 * liHeight) {
          this.showOpen = true;
          this.historyListMinLen = liHeight * 2;
        } else {
          this.showOpen = false;
        }
      } else {
        this.showOpen = false;
      }
    },
    // 点击展开、收回
    handleShowOpen() {
      this.openStatus = !this.openStatus;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@@/styles/mixin.scss';
.search-history {
  padding: rem(20) rem(15) rem(15);
  background: #fff;
}
.title {
  display: flex;
  justify-content: space-between;
  color: #323232;
  font-weight: 800;
  font-size: 15px;
  line-height: 17px;
  img {
    width: rem(16);
  }
}
.list {
  display: flex;
  flex-wrap: wrap;
  margin-top: rem(15);
  overflow: hidden;
  li {
    padding-right: rem(8);
    padding-bottom: rem(8);
  }
  span {
    display: block;
    width: fit-content;
    max-width: rem(302);
    padding: rem(6) rem(12);
    color: #666;
    font-size: 13px;
    background: #f7f7f7;
    border-radius: rem(20);
  }

  .ellipsis {
    display: block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
.close-btn {
  color: #999;
  font-weight: normal;
  font-size: 13px;
}
.clear-history {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  margin: rem(7) 0 0;
  color: #c2c2c2;
  font-size: rem(13);
  line-height: rem(15);
  letter-spacing: 0;
  img {
    width: rem(13);
    margin-right: rem(5);
  }
}
</style>
